import { render, staticRenderFns } from "./ListImports.vue?vue&type=template&id=6aa82efb&"
import script from "./ListImports.vue?vue&type=script&lang=js&"
export * from "./ListImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports